(() => {
    const script = document.currentScript;
    const root = script?.previousElementSibling;
    if (!root?.classList.contains('uk-reference-header')) return;

    const body = document.body;
    const drawer = root.querySelector('[data-uk-mobile-drawer]');
    const openButton = root.querySelector('[data-uk-menu-open]');
    const closeButtons = root.querySelectorAll('[data-uk-menu-close]');
    const mobileMenuTemplate = root.querySelector('[data-uk-mobile-menu-template]');
    const mobileMenuMount = root.querySelector('[data-uk-mobile-menu-mount]');
    let mobileMenuMounted = false;

    const ensureMobileMenu = () => {
      if (mobileMenuMounted || !mobileMenuTemplate || !mobileMenuMount) return;
      mobileMenuMount.appendChild(mobileMenuTemplate.content.cloneNode(true));
      mobileMenuMounted = true;
    };

    const setDrawer = (open) => {
      if (!drawer) return;
      if (open) ensureMobileMenu();
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      openButton?.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.classList.toggle('uk-header-drawer-open', open);
    };

    openButton?.addEventListener('click', () => setDrawer(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => setDrawer(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setDrawer(false);
    });
root.querySelectorAll('.uk-reference-header__menu-details').forEach((details) => {
      let closeTimer;
      const open = () => {
        window.clearTimeout(closeTimer);
        root.querySelectorAll('.uk-reference-header__menu-details[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
        details.open = true;
      };
      const close = () => {
        closeTimer = window.setTimeout(() => { details.open = false; }, 140);
      };
      details.addEventListener('mouseenter', open);
      details.addEventListener('mouseleave', close);
      details.addEventListener('focusin', open);
      details.addEventListener('focusout', (event) => {
        if (!details.contains(event.relatedTarget)) close();
      });
    });

    root.querySelectorAll('[data-uk-menu-parent]').forEach((anchor) => {
      anchor.addEventListener('click', (event) => {
        const href = anchor.getAttribute('href');
        if (!href) return;
        event.preventDefault();
        event.stopPropagation();
        window.location.assign(href);
      });
    });

    const searchWrap = root.querySelector('.uk-reference-header__search');
    const searchInput = searchWrap?.querySelector('.search__input');
    const searchWord = searchWrap?.querySelector('[data-uk-search-word]');

    if (searchWrap && searchInput && searchWord) {
      const fallbackWords = ['Rice', 'Noodles', 'Lotion', 'Snacks', 'Cold Drink', 'Soup'];
      const configuredWords = (searchWrap.dataset.searchPhrases || '')
        .split(',')
        .map((word) => word.trim())
        .filter(Boolean);
      const words = configuredWords.length ? configuredWords : fallbackWords;
      const holdDelay = Math.max(Number(searchWrap.dataset.searchSpeed) || 2200, 1200);
      let wordIndex = 0;
      let timer = null;

      const syncPrompt = () => {
        searchWrap.classList.toggle('has-search-value', searchInput.value.trim().length > 0);
      };

      const rotateWord = () => {
        wordIndex = (wordIndex + 1) % words.length;
        searchWord.classList.add('is-changing');
        window.setTimeout(() => {
          searchWord.textContent = words[wordIndex];
          searchWord.classList.remove('is-changing');
        }, 140);
      };

      searchInput.placeholder = '';
      searchWord.textContent = words[0];
      syncPrompt();
      timer = window.setInterval(rotateWord, holdDelay);

      searchInput.addEventListener('input', syncPrompt);
      searchInput.addEventListener('focus', syncPrompt);
      searchInput.addEventListener('blur', syncPrompt);

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target?.contains(root) && timer) window.clearInterval(timer);
      });
    }

    /* UK Header predictive search — 2026-09-20 */
    if (searchWrap && searchInput) {
      const searchForm = searchWrap.querySelector('[data-uk-search-form]');
      const resultsBox = searchWrap.querySelector('[data-uk-search-results]');
      let searchTimer = null;
      let searchController = null;

      const escapeHTML = (value = '') => String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');

      const setSearchOpen = (open) => {
        if (!resultsBox) return;
        resultsBox.hidden = !open;
        searchInput.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      const closeSearch = () => setSearchOpen(false);

      const productImage = (product) => {
        const image = product?.featured_image;
        if (image && typeof image === 'object') return image.url || '';
        if (typeof image === 'string') return image;
        return product?.image || '';
      };

      const renderResults = (term, payload) => {
        if (!resultsBox) return;
        const results = payload?.resources?.results || {};
        const products = Array.isArray(results.products) ? results.products.slice(0, 5) : [];
        const collections = Array.isArray(results.collections) ? results.collections.slice(0, 5) : [];

        if (!products.length && !collections.length) {
          resultsBox.innerHTML = `
            <div class="uk-reference-header__suggest-empty">
              No results found for “${escapeHTML(term)}”
            </div>
          `;
          setSearchOpen(true);
          return;
        }

        let markup = '';

        if (products.length) {
          markup += '<div class="uk-reference-header__suggest-group">';
          markup += '<div class="uk-reference-header__suggest-heading">Products</div>';
          markup += '<div class="uk-reference-header__suggest-list">';
          products.forEach((product) => {
            const imageUrl = productImage(product);
            const imageMarkup = imageUrl
              ? `<img src="${escapeHTML(imageUrl)}" alt="" loading="lazy" width="48" height="48">`
              : '<span class="uk-reference-header__suggest-image-placeholder"></span>';
            const vendor = product?.vendor
              ? `<span class="uk-reference-header__suggest-meta">${escapeHTML(product.vendor)}</span>`
              : '';
            markup += `
              <a class="uk-reference-header__suggest-product" href="${escapeHTML(product.url || '#')}" role="option">
                <span class="uk-reference-header__suggest-image">${imageMarkup}</span>
                <span class="uk-reference-header__suggest-copy">
                  <span class="uk-reference-header__suggest-title">${escapeHTML(product.title || '')}</span>
                  ${vendor}
                </span>
              </a>
            `;
          });
          markup += '</div></div>';
        }

        if (collections.length) {
          markup += '<div class="uk-reference-header__suggest-group uk-reference-header__suggest-group--collections">';
          markup += '<div class="uk-reference-header__suggest-heading">Collections</div>';
          markup += '<div class="uk-reference-header__suggest-collections">';
          collections.forEach((collection) => {
            markup += `
              <a class="uk-reference-header__suggest-collection" href="${escapeHTML(collection.url || '#')}" role="option">
                <span>${escapeHTML(collection.title || '')}</span>
                <span aria-hidden="true">›</span>
              </a>
            `;
          });
          markup += '</div></div>';
        }

        markup += `
          <a class="uk-reference-header__suggest-all" href="${root.dataset.ukSearchUrl || '/search'}?q=${encodeURIComponent(term)}">
            Search for “${escapeHTML(term)}”
            <span aria-hidden="true">→</span>
          </a>
        `;

        resultsBox.innerHTML = markup;
        setSearchOpen(true);
      };

      const runSearch = async () => {
        const term = searchInput.value.trim();
        if (term.length < 2) {
          closeSearch();
          if (resultsBox) resultsBox.innerHTML = '';
          return;
        }

        searchController?.abort();
        searchController = new AbortController();

        try {
          const params = new URLSearchParams({
            q: term,
            'resources[type]': 'product,collection',
            'resources[limit]': '5',
            'resources[limit_scope]': 'each'
          });

          const response = await fetch(`${window.Shopify?.routes?.root || '/'}search/suggest.json?${params.toString()}`, {
            signal: searchController.signal,
            headers: { 'Accept': 'application/json' }
          });

          if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
          const payload = await response.json();
          if (term !== searchInput.value.trim()) return;
          renderResults(term, payload);
        } catch (error) {
          if (error?.name === 'AbortError') return;
          console.error('UK header predictive search:', error);
          closeSearch();
        }
      };

      searchInput.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(runSearch, 220);
      });

      searchInput.addEventListener('focus', () => {
        if (searchInput.value.trim().length >= 2) runSearch();
      });

      searchForm?.addEventListener('submit', () => closeSearch());

      document.addEventListener('click', (event) => {
        if (!searchWrap.contains(event.target)) closeSearch();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeSearch();
      });
    }

  })();
